// generated
export const GATEWAY_VERSION = "0.12.0-beta";
